import { Component, OnInit, Input } from '@angular/core';
import { QuestItemService } from '../quest-item.service';
//import { AppComponent } from '../../app.component';
import { LoginService } from '../../login.service';

@Component({
  selector: 'qst-score',
  templateUrl: './score.component.html',
  styleUrls: ['./score.component.scss']
})
export class ScoreComponent implements OnInit {
  @Input() name: string;

  currentScore: number;
  possibleScore: number;
  teamName: string;
  teamCode: string;

  constructor(  private questItemService: QuestItemService, 
                private loginService: LoginService ) { }

  ngOnInit(): void {
    console.log("ScoreComponenet.ngOnInit()");
    this.teamName = this.loginService.getTeamName();
    this.currentScore = this.questItemService.getCurrentScore();
    this.possibleScore = this.questItemService.getPossibleScore();
  }

  updateCurrentScore(score: number) {
    console.log("ScoreComponent.updateCurrentScore: " + score);
    this.currentScore = score;
  }

  updateScore(score: String) {

  }

}
